var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "avatar/location/Hotel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "avatar/location/Hotel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#F2F2F2",
    points: "19 64 61 64 61 16 19 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,64 L34,45 L46,45 L46,64 L34,64 Z M25,34 L25,23 L31,23 L31,34 L25,34 Z M37,34 L37,23 L43,23 L43,34 L37,34 Z M49,34 L49,23 L55,23 L55,34 L49,34 Z M49,56 L49,45 L55,45 L55,56 L49,56 Z M25,56 L25,45 L31,45 L31,56 L25,56 Z",
    id: "Combined-Shape",
    fill: "#313036"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#B34B85",
    points: "34.0003 63.9997 29.9993 69.9997 49.9993 69.9997 46.0003 63.9997"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#B34B85",
    points: "21 16 59 16 59 10 21 10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fillOpacity: 0.25,
    fill: "#000000",
    points: "46 45 27 64 19 64 19 58 35.892 40.638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46,45 L34,45 C34,41.687 36.687,39.019 40,39.019 C43.313,39.019 46,41.687 46,45",
    id: "Fill-12",
    fill: "#B34B85"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/Hotel.46441b7a5e294f14c2def5dc4dcbcdea.svg";
export { ForwardRef as ReactComponent };